// src/hooks/pricingUnits/useDeletePricingUnit.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deletePricingUnit } from "../../api/apiPricingUnits";
import parseError from "../../utils/parseError";

const useDeletePricingUnit = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deletePricingUnitMutation,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: deletePricingUnit,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["pricingUnits"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete pricing unit");
        },
    });

    return {
        deletePricingUnit: deletePricingUnitMutation,
        isPending: isPending || isLoading,
    };
};

export default useDeletePricingUnit;
